
import {map,  catchError, finalize, delay } from 'rxjs/operators';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import { BehaviorSubject, Observable ,  of } from 'rxjs';
import { CrudOperations } from '../../interfaces/crudOperations';
import { BaseEntity } from '../BaseEntity';
import { IQueryResult } from '../interfaces/IQueryResult';
import { IPageInfo } from '../interfaces/IPageInfo';
import { PageEvent } from '@angular/material';

export class BasePagedDataSource<T extends BaseEntity> implements DataSource<T> {
 private typeSubject = new BehaviorSubject<T[]>([]);
 private loadingSubject = new BehaviorSubject<boolean>(false);
 public loading$ = this.loadingSubject.asObservable();
 /**
  *
  */
 private typeService: CrudOperations<T>;
 private filter: any;
 private sort: string;
 private sortDec: boolean = false;
 public pageInfo: IPageInfo = null;
 public pageSizeOptions: number[];
 public pageEvent: PageEvent;
 constructor(service: CrudOperations<T>, filter?: any, sort?: string, pageSizeOptions?: number[], sortdesc:boolean = false) {
     this.typeService = service;
     this.filter = filter;
     this.sort = sort;
     this.sortDec = sortdesc;
     this.pageSizeOptions = pageSizeOptions || [20, 50, 100];
 }
 connect(collectionViewer: CollectionViewer): Observable<T[]> {
     return this.typeSubject.asObservable();
 }
 disconnect() {
     this.typeSubject.complete();
     this.loadingSubject.complete();
 }

 public loadData(pageEvent?: PageEvent) {

    this.loadingSubject.next(true);
    let pagesize = this.pageSizeOptions ? this.pageSizeOptions[0] : 50;
    let page = 1;
    if (pageEvent) {
        if (pageEvent.pageSize > 0) {
            pagesize = pageEvent.pageSize;
        }
        if (pageEvent.pageIndex) {
            page = pageEvent.pageIndex + 1;
        }
    }
    const sort = this.sortDec?'desc':'asc';
    this.typeService.Filter(this.filter, this.sort, sort, page, pagesize).pipe(
    map(type => {
        if (type.pageInfo) {
            this.pageInfo = type.pageInfo;
        }

        return type.payload;
    }))
    .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
    ).subscribe(type => {
        this.typeSubject.next(type);
    });
    }
}
